import { SCREEN_NAME } from '../constants'

export const formatPathname = (referrer: string) => {
  if (!referrer) {
    return 'Guest Homepage'
  }

  try {
    const referrerUrl = new URL(referrer)
    const { pathname } = referrerUrl

    // Adapt url to correct string format
    const words = pathname.replace(/\/|-/g, ' ').split(' ')
    const formattedWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    let formattedString = formattedWords.join(' ')
    formattedString = formattedString.trimStart()

    return formattedString === 'Cms Index Home' ? SCREEN_NAME : formattedString
  } catch (error) {
    // Handle invalid URL
    return 'Invalid URL'
  }
}
